import { makeStyles } from "tss-react/mui";
const useClasses = makeStyles()((theme) => ({
  autoAdjustedWidthTooltipLabel: {
    lineHeight: theme.typography.body1.lineHeight,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis"
  },
  autoAdjustedWidthTooltip: {
    whiteSpace: "pre",
    maxHeight: "50vh",
    overflowY: "auto"
  }
}));
export {
  useClasses
};
//# sourceMappingURL=AutoAdjustedWidthTooltip.styles.js.map
